"use strict";const t=require("./index22.js"),r=require("./index23.js"),e=require("./index24.js");var i=t.toStringTagSupport,n=r.defineBuiltIn,o=e.objectToString;i||n(Object.prototype,"toString",o,{unsafe:!0});
